import React from "react";
import "./ContactUs.css";
import mantexting from "../../assets/mantexting.png";
import call from "../../assets/call.png";
import bagtimer from "../../assets/bag-timer.png";
import pen from "../../assets/pen.png";
import firstgirlimage from "../../assets/firstgirlimage.jpeg";
import flag from "../../assets/flag.png";
import redphone from "../../assets/redphone.png";
import globe from "../../assets/globe.png";
import { FaLocationDot } from "react-icons/fa6"; 
import { BsGlobeCentralSouthAsia } from "react-icons/bs";
import { IoCall } from "react-icons/io5";
import { FaGlobe } from "react-icons/fa";
import { IoCallOutline } from "react-icons/io5";
import { MdOutlineBusinessCenter } from "react-icons/md";
import { TbPencilPlus } from "react-icons/tb";
import { FaPhoneAlt } from "react-icons/fa";
import { BsGlobe } from "react-icons/bs";
import { IoIosCall } from "react-icons/io";
 
const ContactUs = () => {
  return (
    <>
      <div className="contact-us-body">
        <div className="about-us-main-body">
          <div className="about-us-body">
            <div>
              <p className="we-are-text">Contact Us</p>
            </div>
            <div>
              <p className="higher-text">
                Hruthi AI Tech Hub is an online higher education platform providing
                rigorous industry-relevant programs designed and delivered in
                collaboration with world-class faculty and industry. Merging the
                latest technology, pedagogy, and services, Hruthi AI Tech Hub is creating
                an immersive learning experience – anytime and anywhere.
              </p>
            </div>
            <div className="watchh-btn-body">
              <button className="watchh-btn">Talk to a Counsellor</button>
            </div>
          </div>
          <div>
            <img src={mantexting} alt="Man texting" className="youtube-logo" />
          </div>
        </div>

        <div className="call-text-body">
          <p className="call-text">Call or Email Us</p>
        </div>

        <div className="for-program-main-body">
          <div className="for-program-body">
            <div className="call-img-body">
              {/* <img src={call} alt="Call_icon" className="call-logo-img" /> */}
              <IoCallOutline size={50} color="#ff3131"/>
            </div>
            <div className="call-img-body">
              <p className="for-program-text">For Program Related Queries</p>
            </div>
            <div className="call-img-body">
              <p className="num-ber">+91-89779 17381
              </p>
            </div>
            <div className="call-img-body">
              <p className="customer-care">hruthiaitechhub@gmail.com</p>
            </div>
          </div>
          <div className="for-program-body">
            <div className="call-img-body">
              {/* <img src={bagtimer} alt="Bag timer icon" className="call-logo-img" /> */}
              <MdOutlineBusinessCenter size={50} color="#ff3131"/>
            </div>
            <div className="call-img-body">
              <p className="for-program-text">For Business Related Queries</p>
            </div>
            <div className="call-img-body">
              <p className="num-ber">+91-89779 17381
              </p>
            </div>
            <div className="call-img-body">
              <p className="customer-care">hruthiaitechhub@gmail.com</p>
            </div>
          </div>
          <div className="for-program-body">
            <div className="call-img-body">
              {/* <img src={pen} alt="Pen icon" className="call-logo-img" /> */}
              <TbPencilPlus size={50} color="#ff3131"/>
            </div>
            <div className="call-img-body">
              <p className="for-program-text">For Guest Blog Inquiries</p>
            </div>
            <div className="call-img-body">
              <p className="num-ber">+91-89779 17381
              </p>
            </div>
            <div className="call-img-body">
              <p className="customer-care">hruthiaitechhub@gmail.com</p>
            </div>
          </div>
        </div>

        <div className="call-text-bodyy">
          <p className="call-text">Our office</p>
        </div>

        <div className="cu-comp">
  <img src={firstgirlimage} alt="Hyderabad office" className="mumbai-image" />
  <div className="mumbai-text-body">
    <div className="logo-img-body-1">
      <FaLocationDot className="logo-img" />
       <p className="mumbai-text">Hyderabad</p>
    </div>
    <div className="logo-img-body">
     
    </div>
    <div className="logo-img-body">
      <p className="ground-floor-text">
        #506/B,5th Floor,<br />
        Aditya Enclave, <br />
        Nilagiri Block,<br />
        Ameerpet, Hyderabad<br />
        Telangana, India - 500038.
      </p>
    </div>
  </div>
</div>


<div className="support-container">
      <h2 className="support-title">
        Hruthi AI Tech Hub <span className="support-highlight">Learner Support</span>
      </h2>
      <p className="support-subtitle">
        Talk to our experts. We are available 7 days a week, 9 AM to 12 AM (midnight)
      </p>

      <div className="support-options">
        {/* Indian Nationals */}
        <div className="support-box">
          <img src="https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg" alt="India Flag" className="support-flag-icon" />
          <div><div className="cu-comp">
 
</div>
</div>
          <span className="support-label">Indian Nationals</span>
          <div className="support-phone-box">
            <FaPhoneAlt className="support-phone-icon" />
            <span className="support-phone-number">1800 210 2020</span>
          </div>
        </div>

        {/* Foreign Nationals */}
        <div className="support-box">
          <BsGlobe className="support-globe-icon" />
          <span className="support-label">Foreign Nationals</span>
          <div className="support-phone-box">
            <IoIosCall className="support-phone-icon" />
            <span className="support-phone-number">+918045604032</span>
          </div>
        </div>
      </div>
    </div>
  

        <div className="disclaimer-body">
          <p className="disclaimerr-text">Disclaimer</p>
          <p className="disclaimer-textt">
            Hruthi AI Tech Hub does not grant credit; credits are granted, accepted or
            transferred at the sole discretion of the diploma or degree. We advise you to enquire
            further regarding the suitability of this for your future prospects before enrolling...
          </p>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
